import { observable, computed, action } from 'mobx';
import dataSelectAdapter from 'adapters/DataSelectsAdapter';

class DataSelectStore {
  //TODO: refactor clearMaps logic
  selectItemsMap = {
    datatype: {
      clearMaps: [ 'clearTvs', 'clearAssetClasses', 'clearSubAssetClasses', 'clearInstruments', 'clearSegmentMics', 'clearOrderTypes' ],
      loadMap: 'loadTvs',
      loadParams: [ 'datatype' ]
    },
    tv: {
      clearMaps: [ 'clearAssetClasses', 'clearSubAssetClasses', 'clearInstruments', 'clearSegmentMics', 'clearOrderTypes' ],
      loadMap: 'loadAssetClasses',
      loadParams: [ 'datatype', 'tv' ]
    },
    assetclass: {
      clearMaps: [ 'clearSubAssetClasses', 'clearInstruments', 'clearSegmentMics', 'clearOrderTypes' ],
      loadMap: 'loadSubAssetClasses',
      loadParams: [ 'datatype', 'tv', 'assetclass' ]
    },
    subassetclass: {
      clearMaps: [ 'clearInstruments', 'clearSegmentMics', 'clearOrderTypes' ],
      loadMap: 'loadInstruments',
      loadParams: [ 'datatype', 'tv', 'assetclass', 'subassetclass' ]
    },
    instrument: {
      clearMaps: [ 'clearSegmentMics', 'clearOrderTypes' ],
      loadMap: 'loadSegmentMics',
      loadParams: [ 'datatype', 'tv', 'assetclass', 'subassetclass', 'instrument' ]
    },
    instrumentmic: {
      clearMaps: [ 'clearOrderTypes' ],
      loadMap: 'loadOrderTypes',
      loadParams: [ 'datatype', 'tv', 'assetclass', 'subassetclass', 'instrument', 'instrumentmic' ]
    }
  };

  @observable
  orderTradeMap = observable.map({
    order: {
      value: 'order',
      label: 'Orders'
    },
    trade: {
      value: 'trade',
      label: 'Trades'
    }
  });

  @observable tvsMap = observable.map();
  @observable assetClassesMap = observable.map();
  @observable subAssetClassesMap = observable.map();
  @observable instrumentsMap = observable.map();
  @observable segmentMicsMap = observable.map();
  @observable orderTypesMap = observable.map();

  isOrderTradeLoading = false;
  @observable isTvLoading = false;
  @observable isAssetClassesLoading = false;
  @observable isSubAssetClassesLoading = false;
  @observable isInstrumentsLoading = false;
  @observable areSegmentMicsLoading = false;
  @observable areOrderTypesLoading = false;
  @observable isSegmentMicLoadingFailed = false;

  @computed
  get orderTrades() {
    return this.orderTradeMap.values();
  }

  @computed
  get tvs() {
    return this.tvsMap.values();
  }

  @computed
  get assetClasses() {
    return this.assetClassesMap.values();
  }

  @computed
  get subAssetClasses() {
    return this.subAssetClassesMap.values();
  }

  @computed
  get instruments() {
    return this.instrumentsMap.values();
  }

  @computed
  get segmentMics() {
    return this.segmentMicsMap.values();
  }

  @computed
  get orderType() {
    return this.orderTypesMap.values();
  }

  @computed
  get orderTypeCount() {
    return this.orderType.length;
  }

  @computed
  get segmentMicsCount() {
    return this.segmentMics.length;
  }

  @action
  clearTvs() {
    this.tvsMap.clear();
  }

  @action
  clearAssetClasses() {
    this.assetClassesMap.clear();
  }

  @action
  clearSubAssetClasses() {
    this.subAssetClassesMap.clear();
  }

  @action
  clearInstruments() {
    this.instrumentsMap.clear();
  }

  @action
  clearSegmentMics() {
    this.segmentMicsMap.clear();
  }

  @action
  clearOrderTypes() {
    this.orderTypesMap.clear();
  }

  @action
  loadTvs(params) {
    this.isTvLoading = true;
    dataSelectAdapter
      .loadTVs(params)
      .then(
        action((results) => {
          this.fillMapFromArray(this.tvsMap, results);
          this.isTvLoading = false;
        })
      )
      .catch(() => {
        this.isTvLoading = false;
      });
  }

  @action
  loadAssetClasses(params) {
    this.isAssetClassesLoading = true;
    dataSelectAdapter
      .loadAssetClasses(params)
      .then(
        action((results) => {
          this.fillMapFromArray(this.assetClassesMap, results);
          this.isAssetClassesLoading = false;
        })
      )
      .catch(() => {
        this.isAssetClassesLoading = false;
      });
  }

  @action
  loadSubAssetClasses(params) {
    this.isSubAssetClassesLoading = true;
    dataSelectAdapter
      .loadSubAssetClasses(params)
      .then(
        action((results) => {
          this.fillMapFromArray(this.subAssetClassesMap, results);
          this.isSubAssetClassesLoading = false;
        })
      )
      .catch(() => {
        this.isSubAssetClassesLoading = false;
      });
  }

  @action
  loadInstruments(params) {
    this.isInstrumentsLoading = true;
    dataSelectAdapter
      .loadInstruments(params)
      .then(
        action((results) => {
          this.fillMapFromArray(this.instrumentsMap, results);
          this.isInstrumentsLoading = false;
        })
      )
      .catch(() => {
        this.isInstrumentsLoading = false;
      });
  }

  @action
  loadSegmentMics(params) {
    this.areSegmentMicsLoading = true;
    this.isSegmentMicLoadingFailed = false;
    dataSelectAdapter
      .loadSegmentMics(params)
      .then(
        action((results = []) => {
          this.fillMapFromArray(this.segmentMicsMap, results);
          this.areSegmentMicsLoading = false;
          if(this.segmentMicsCount === 1) {
            const instrumentmic = results[0].value;
            this.loadOrderTypes({ ...params, instrumentmic });
          }
        })
      )
      .catch(() => {
        this.isSegmentMicLoadingFailed = true;
        this.areSegmentMicsLoading = false;
      });
  }


  @action
  loadOrderTypes(params) {
    this.areOrderTypesLoading = true;
    dataSelectAdapter
      .loadOrderTypes(params)
      .then(
        action((results = []) => {
          this.fillMapFromArray(this.orderTypesMap, results);
          this.areOrderTypesLoading = false;
        })
      )
      .catch(err => {
        this.areOrderTypesLoading = false;
      });
  }

  @action
  onChangeSelect(value, name, values) {
    const itemMap = this.selectItemsMap[name];
    if (!itemMap) {
      return;
    }

    itemMap.clearMaps.forEach((itemClear, index) => {
      this[itemClear]();
    });
    if (value) {
      const params = {};
      itemMap.loadParams.forEach((paramName) => {
        params[paramName] = values[paramName];
      });
      this[itemMap.loadMap](params);
    }
  }

  @action
  clearSelectData() {
    [
      this.tvsMap,
      this.assetClassesMap,
      this.subAssetClassesMap,
      this.instrumentsMap,
      this.segmentMicsMap,
      this.orderTypesMap
    ].forEach((m) => m.clear());
  }

  // helpers
  fillMapFromArray(map, array) {
    array.forEach(item => {
      map.set(item.value, item);
    });
  }

  @computed
  get isUpdating() {
    return [
        this.isOrderTradeLoading,
        this.isTvLoading,
        this.isAssetClassesLoading,
        this.isSubAssetClassesLoading,
        this.isInstrumentsLoading,
        this.areSegmentMicsLoading,
        this.areOrderTypesLoading
    ].reduce((prev, cur) => prev || cur);
  }
}

const dataSelectStore = new DataSelectStore();

export default dataSelectStore;



// WEBPACK FOOTER //
// ./src/stores/DataSelectStore.js